import { render, staticRenderFns } from "./PermanentJobDetail.vue?vue&type=template&id=1d83ef8b&scoped=true"
import script from "./PermanentJobDetail.vue?vue&type=script&lang=ts"
export * from "./PermanentJobDetail.vue?vue&type=script&lang=ts"
import style0 from "./PermanentJobDetail.scss?vue&type=style&index=0&id=1d83ef8b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d83ef8b",
  null
  
)

export default component.exports